<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12>
        <v-select :items="branchList" v-model="globalModalParams.quote.store_name" placeholder="Survey Type" class="dropdown" item-value="code" item-text="name" autocomplete solo outline></v-select>
        <v-btn class="text-xs-right" color="success" @click.stop="fncUpdateStore()">Update Store</v-btn>
      </v-flex>

      <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>

  </v-container>
  <!--<v-container grid-list-lg>
    <v-layout row wrap>
      <v-text-field v-model="quoteNo" solo single-line></v-text-field>
    </v-layout>
  </v-container>-->
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "Modal_clone_quote",
  data () {
    return {
      storeCode: '',
    }
  },
  methods: {
    fncUpdateStore() {
      this.$store.dispatch('fncUpdateStore', this.globalModalParams.quote);
    },
    fncUnarchiveQuote( id ) {
      this.$store.dispatch('fncUnarchiveQuote', id);
    },
    fncHideModal() {
      // this.$store.commit('hideModal');
      window.location.reload();
    },

  },
  computed: {
    ...mapGetters([
      'globalModalParams',
      'branchList'
    ])
  },
  beforeMount() {
  },
  mounted() {
    console.log( this.globalModalParams );
    console.log( this.branchList );
  }
}
</script>

<style scoped>

</style>
